import React from 'react';
import {graphql} from 'react-apollo';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';
import queries from '../../../utils/queries';

//dropdown USUARIOS
const DetalleNivelUser = props => {
  return (
    <option dato1={props.elemento._id}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaUsr = ({styles, handleChange, list}) => {
  const NivelDetalleUser = list.map((elemento, _id) => <DetalleNivelUser elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleUser}
      </select>
    </div>
  )
};
//Fin dropdown USUARIOS

// const CambClaveOU2 = ({styles, usuActivo, list, handleSubmit, handleChange, args, errors, handleClickRegr}) => {
class CambClaveOU2 extends React.Component {
  state={
    argsDocum: {nombreUsuario: "Seleccionar...", _id: ""},
  }

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value

    var miLista = document.getElementById("miLista");
    argsDocum['_id'] = miLista.options[miLista.selectedIndex].attributes[0].value

    this.setState({argsDocum});
  }

  render(){
    const {argsDocum} = this.state;
    // console.log(this.props.args, argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Cambiar clave de acceso a otro usuario
        </button>
        <div style={this.props.styles.box}>
          <Form onSubmit={(ev)=>{
            this.props.handleSubmit(ev, this.props.args, argsDocum)}
            // handleClickRegr(ev)}
          }>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Usuario</label>
                    <ListaUsr list={this.props.list} styles={this.props.styles} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>NUEVA clave de acceso</label>
                    <input style={this.props.styles.input} autoComplete="off" name="claveDeAccesoNva1" id="claveDeAccesoNva1" onChange={this.props.handleChange} type='password' placeholder='Clave de acceso nueva' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Repetir NUEVA clave de acceso</label>
                    <input style={this.props.styles.input} autoComplete="off" name="claveDeAccesoNva2" id="claveDeAccesoNva2" onChange={this.props.handleChange} type='password' placeholder='Clave de acceso nueva' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>

                  <Divider inverted />

                  <Button style={this.props.styles.confirmar} type='submit' fluid>
                      CAMBIAR CLAVE DE ACCESO A OTRO USUARIO
                  </Button>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default graphql(queries.query.allPerfiles)(CambClaveOU2)
